module.exports = __webpack_public_path__ + "img/field2.81fbdb85.png";